import React from 'react';
import { selectorCSS } from './InsuranceSelector.css';
import { calculatorChubbLogo, calculatorGnpLogo, calculatorHdiLogo, calculatorQualitasLogo } from '../../../../../Assets/Images';
import { formatNumber } from '../../../../../Utils';
import { TbReload } from "react-icons/tb";
import { motion, AnimatePresence } from 'framer-motion';
const FRASES = [
    'Explorando seguros…',
    'Eligiendo el mejor precio…',
    'Comparando coberturas…',
    'Buscando la mejor opción…',
    'Consultando aseguradoras…',
];

const InsuranceLogoLoader = () => {
    const [idx, setIdx] = React.useState(0);
    React.useEffect(() => {
        const id = setInterval(() => setIdx(i => (i + 1) % FRASES.length), 2000);
        return () => clearInterval(id);
    }, []);
    return (
    <span className="ins-logo-loader">
        <svg
            className="ins-loader-svg"
            width="154"
            height="92"
            viewBox="0 0 154 92"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <linearGradient id="ins-loader-grad" x1="5" y1="47.3905" x2="149" y2="47.3905" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#00BA6E" />
                    <stop offset="1" stopColor="#32B8DF" />
                </linearGradient>
                <filter id="ins-loader-glow">
                    <feGaussianBlur stdDeviation="2" result="blur" />
                    <feMerge>
                        <feMergeNode in="blur" />
                        <feMergeNode in="SourceGraphic" />
                    </feMerge>
                </filter>
            </defs>
            <path
                className="ins-loader-path"
                d="M83.4803 33.9912C78.2136 17.644 62.7721 5.86615 44.6194 6.12321C22.5937 6.43459 4.77768 24.7151 5.0021 46.7466C5.2229 68.7673 23.1367 86.5518 45.2058 86.5518C54.9753 86.5518 64.2453 83.4235 70.8983 77.2685C88.6817 60.8236 138.499 7.86111 138.499 7.86111C142.329 3.92911 149 6.64096 149 12.1334V88"
                stroke="url(#ins-loader-grad)"
                strokeWidth="10"
                strokeMiterlimit="10"
                strokeLinecap="round"
                filter="url(#ins-loader-glow)"
            />
        </svg>
        <span className="ins-loader-frase" key={idx}>{FRASES[idx]}</span>
    </span>
    );
};

function InsuranceSelector({ options, selected, onChange, disabled, loadFunction, loading, divideAmountBy = 1 }) {

    function getLogo(name) {
        try {
            let str = name.toString().toLowerCase();
            if (str.search('gnp') > -1) return calculatorGnpLogo;
            if (str.search('hdi') > -1) return calculatorHdiLogo;
            if (str.search('qualitas') > -1) return calculatorQualitasLogo;
            if (str.search('chubb') > -1) return calculatorChubbLogo;
            return null;
        } catch (error) {
            return null;
        }
    }

    function getInsuranceName(name) {
        try {
            let str = name.toString().toLowerCase();
            if (str.search('gnp') > -1) return 'GNP';
            if (str.search('hdi') > -1) return 'HDI';
            if (str.search('qualitas') > -1) return 'Qualitas';
            if (str.search('chubb') > -1) return 'Chubb';
            return name.split(' - ')[0];
        } catch {
            return '';
        }
    }

    return (
        <div css={selectorCSS()}>
            {options.length < 1 ? (
                loading ? (
                    <InsuranceLogoLoader />
                ) : (
                    <div
                        className={'Empty ' + (disabled ? 'Disabled' : '')}
                        onClick={disabled ? () => null : loadFunction}
                    >
                        {disabled ?
                            'Completa la información requerida'
                            :
                            <>
                                <div className="Icon"><TbReload /></div>
                                <span>Da click para cargar los seguros</span>
                            </>
                        }
                    </div>
                )
            ) : (
            <div className="Container">
                <AnimatePresence>
                    {options && options.map((obj, i) => {
                        const isSelected = selected == obj.id;
                        const monthly = formatNumber((obj.amount / divideAmountBy).toFixed(2));
                        const total = formatNumber((obj.amount).toFixed(2));
                        const logo = getLogo(obj.insurance);
                        const insuranceName = getInsuranceName(obj.insurance);

                        return (
                            <motion.div
                                className="CardContainer"
                                key={obj.id}
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.35, delay: i * 0.08 }}
                                onClick={() => onChange(obj.id)}
                            >
                                <motion.div
                                    className="Card"
                                    animate={{
                                        scale: isSelected ? 1.04 : 1,
                                    }}
                                    whileHover={{ scale: 1.06, y: -3 }}
                                    whileTap={{ scale: 0.97 }}
                                    transition={{ type: 'spring', stiffness: 350, damping: 22 }}
                                >
                                    <div className="contentCard">
                                        <div className="logoArea">
                                            {logo
                                                ? <img src={logo} alt={insuranceName} />
                                                : <span className="fallbackName">{insuranceName}</span>
                                            }
                                        </div>
                                        <span className="labelText">seguro mensual</span>
                                    </div>
                                    <motion.div
                                        className="footerCard"
                                        animate={{
                                            backgroundColor: isSelected ? '#204B7B' : '#22EC9A',
                                        }}
                                        transition={{ duration: 0.3 }}
                                    >
                                        <div className="textContent">
                                            <motion.span
                                                className="price"
                                                animate={{ color: isSelected ? '#22EC9A' : '#ffffff' }}
                                                transition={{ duration: 0.3 }}
                                            >
                                                ${monthly}
                                            </motion.span>
                                            <motion.span
                                                className="text"
                                                animate={{ color: isSelected ? '#22EC9A' : '#ffffff' }}
                                                transition={{ duration: 0.3 }}
                                            >
                                                /mes
                                            </motion.span>
                                        </div>
                                    </motion.div>
                                </motion.div>
                                <div className="totalLine">
                                    ${total} total
                                </div>
                                <div className="shadowCard" />
                            </motion.div>
                        );
                    })}
                </AnimatePresence>
            </div>
            )}
        </div>
    );
}

export { InsuranceSelector };
